import {gql} from "@apollo/client";
import {Brand} from "@App/types";

export interface VehicletreeEquipmentsQuery {
    brands: Brand[]
}

export const GET_VEHICLE_EQUIPMENTS = gql`
    query getVehicleEquipments($brandId: ID, $generationId: ID, $motorizationId: ID, $brandSlug: String, $generationSlug: String, $motorizationSlug: String, $gearboxId: ID!, $initialRegistrationDate: DateTimeTz!, $includeGenerations: Boolean!, $includeMotorizations: Boolean!) {
        brands(id: $brandId, slug: $brandSlug) {
            id
            generations(id: $generationId, slug: $generationSlug) @include(if: $includeGenerations) {
                id
                motorizations(id: $motorizationId, slug: $motorizationSlug) @include(if: $includeMotorizations) {
                    id
                    equipment(gearbox: $gearboxId, initial_registration_date: $initialRegistrationDate) {
                        id
                        name
                    }
                }
            }
        }
    }
`;
